import React from 'react'
import PropTypes from 'prop-types'

// The golfer search box; Enter adds the first result, suppressing the form submit in one place.
const GolferSearchInput = ({ id, value, onChange, onEnter, placeholder, ariaLabel }) => {
  const handleKeyDown = (event) => {
    if (event.key !== 'Enter') { return }
    event.preventDefault()
    if (onEnter) { onEnter() }
  }

  return (
    <div className="gl-event-setup-search-input-wrap">
      <span className="gl-event-setup-search-ico" aria-hidden="true">&#128269;</span>
      <input
        id={id}
        className="gl-event-setup-search-input"
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </div>
  )
}

GolferSearchInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
}

export default GolferSearchInput
